import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import MentionLegal from "@/views/MentionLegal.vue";
import HomeView from "@/views/HomeView.vue";
import AboutView from "@/views/AboutView.vue";
import ProviderView from "@/views/services/ProviderView.vue";
import LivrateurView from "@/views/services/LivrateurView.vue";
import ArtisanView from "@/views/services/ArtisanView.vue";
import BlogView from "@/views/BlogView.vue";
import ContactView from "@/views/ContactView.vue";
import RegisterView from "@/views/RegisterView.vue";
import LoginView from "@/views/LoginView.vue";
import PostView from "@/views/PostView.vue";
import TownView from "@/views/TownView.vue";
import CreationTownView from "@/views/CreationTownView.vue";
import ProfileView from "@/views/ProfileView.vue";
import EditPostView from "@/views/EditPostView.vue";
import CreatePostView from "@/views/CreatePostView.vue";
import CreateTownView from "@/views/CreateTownView.vue";
import DashBoard from "@/views/malazone/DashBoard.vue";
import MalaTowns from "@/views/malazone/MalaTowns.vue";
import MalaUsers from "@/views/malazone/MalaUsers.vue";
import MalaCats from "@/views/malazone/MalaCats.vue";
import MalaTags from "@/views/malazone/MalaTags.vue";
import MalaPosts from "@/views/malazone/MalaPosts.vue";
import MalaMedias from "@/views/malazone/MalaMedias.vue";

const routes = [
  {
    path: "/mentions",
    name: "mentions",
    component: MentionLegal,
  },

  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/home",
    name: "Home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    component: AboutView,
  },
  {
    path: "/livraisons-fournisseurs-btp",
    name: "Fournisseur",
    component: ProviderView,
  },
  {
    path: "/missions-pour-livreurs",
    name: "Livrateur",
    component: LivrateurView,
  },
  {
    path: "/livraison-sur-chantier",
    name: "Artisans",
    component: ArtisanView,
  },
  {
    path: "/contact",
    name: "contact",
    component: ContactView,
  },
  {
    path: "/blog",
    name: "blog",
    component: BlogView,
  },
  {
    path: "/update/:slug",
    name: "edit",
    component: EditPostView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/new-article",
    name: "create",
    component: CreatePostView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/new-town/",
    name: "UploadTown",
    component: CreateTownView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/article/:slug",
    name: "article",
    component: PostView,
  },
  {
    path: "/livraisons-chantier/:slug",
    name: "Landing-Provider",
    component: TownView,
  },
  {
    path: "/missions-livreurs/:town",
    name: "Landing-delivery",
    component: CreationTownView,
  },
  {
    path: "/register",
    name: "Register",
    component: RegisterView,
    meta: { guest: true },
  },
  {
    path: "/login",
    name: "Login",
    component: LoginView,
    meta: { guest: true },
  },
  {
    path: "/profile/:pseudo",
    name: "profile",
    component: ProfileView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/malazone",
    name: "malazone",
    component: DashBoard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/malazone/users",
    name: "mala-users",
    component: MalaUsers,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/malazone/villes",
    name: "mala-towns",
    component: MalaTowns,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/malazone/posts",
    name: "mala-posts",
    component: MalaPosts,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/malazone/categories",
    name: "mala-cats",
    component: MalaCats,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/malazone/tags",
    name: "mala-tags",
    component: MalaTags,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/malazone/medias",
    name: "mala-medias",
    component: MalaMedias,
    meta: {
      requiresAuth: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return new Promise((resolve) => {
      resolve({ left: 0, top: 0 });
    });
  },
});
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isAuthenticated) {
      next();
      return;
    }
    next("/login");
  } else {
    next();
  }
});
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.guest)) {
    if (store.getters.isAuthenticated) {
      next("/malazone");
      return;
    }
    next();
  } else {
    next();
  }
});

export default router;
